
export class StyrtabellLanKommunDistriktDTO   {

    lanKod: string;
    kommunKod: string;
    lkdKod: string;

    constructor() {
        this.lanKod = undefined;
        this.kommunKod = undefined;
        this.lkdKod = undefined;
    }
}
